'use strict';

/*
 * heroBlueprint.js -- decides WHEN the home hero blueprint artwork plays.
 *
 * All motion lives in css/scss/components/_hero.scss; this module only moves state classes on
 * svg.pw-blueprint. Contract: specs/003-animated-hero-blueprint/contracts/blueprint-artwork.md (S1-S7).
 *
 *   is-armed   (Razor)  hidden pre-animation state, plus a CSS failsafe that finishes it after 6s
 *   is-ready   (here)   the script owns playback; cancels the failsafe
 *   is-playing (here)   runs the sequence, once, when visible and the tab is in the foreground
 *   is-done    (here)   finished
 *
 * Every exit path must REMOVE is-armed, not just add is-done: once is-ready is set the failsafe no
 * longer applies, so a lingering is-armed would leave the artwork hidden for good.
 */

function finish(svg) {
    svg.classList.add('is-ready', 'is-done');
    svg.classList.remove('is-armed', 'is-playing');
}

function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
}

function arm(svg) {
    var lastBadge = svg.querySelector('.bp-b2');

    // S7: the script arrived after the CSS failsafe already showed the finished frame. Never replay it.
    if (!lastBadge || window.getComputedStyle(lastBadge).opacity === '1') {
        finish(svg);
        return;
    }

    // S1
    svg.classList.add('is-ready');

    // S2
    if (reducedMotion() || !('IntersectionObserver' in window)) {
        finish(svg);
        return;
    }

    var played = false;
    var intersecting = false;
    var observer;

    function play() {
        if (played || !intersecting || document.visibilityState !== 'visible') {
            return;
        }
        played = true;
        observer.disconnect();
        document.removeEventListener('visibilitychange', play);
        svg.classList.add('is-playing');
    }

    // S5
    svg.addEventListener('animationend', function (e) {
        if (e.target === lastBadge) {
            finish(svg);
        }
    });

    // S3 / S4
    observer = new IntersectionObserver(function (entries) {
        intersecting = entries[entries.length - 1].isIntersecting;
        play();
    }, { threshold: 0.35 });

    document.addEventListener('visibilitychange', play);
    observer.observe(svg);
}

function init(root) {
    var scope = root || document;
    var artworks = scope.querySelectorAll('svg.pw-blueprint.is-armed');
    for (var i = 0; i < artworks.length; i++) {
        arm(artworks[i]);
    }
}

module.exports = { init: init };
